import { lazy } from "react";
import { ROUTES } from "../constants/routes";

// Lazy-loaded components
const MainPage = lazy(() => import("../pages/MainPage"));
const FaqPage = lazy(() => import("../pages/FaqPage"));
const ContactPage = lazy(() => import("../pages/ContactPage"));
const AboutPage = lazy(() => import("../pages/AboutPage"));
const ProductPage = lazy(() => import("../pages/ProductPage"));
const ProductDetailPage = lazy(() => import("../pages/ProductDetailPage"));

// Define route types
export type RouteType = "public" | "private";

export interface AppRoute {
	path: string;
	// eslint-disable-next-line
	component: React.LazyExoticComponent<React.ComponentType<any>>;
	type: RouteType;
}

// Define all your routes in a configuration object
export const routesConfig: AppRoute[] = [
	{
		path: ROUTES.HOME,
		component: MainPage,
		type: "public",
	},
	{
		path: ROUTES.FAQ,
		component: FaqPage,
		type: "public",
	},
	{
		path: ROUTES.CONTACT,
		component: ContactPage,
		type: "public",
	},
	{
		path: ROUTES.ABOUT,
		component: AboutPage,
		type: "public",
	},
	{
		path: ROUTES.PRODUCTS,
		component: ProductPage,
		type: "public",
	},
	{
		path: ROUTES.PRODUCT_DETAILS,
		component: ProductDetailPage,
		type: "public",
	},
];
